if(!window.vef) window.vef = {};